<script>
    export let questionset_id;
    export let question;
    export let user_language;
    export let responses;
    import question_translations_misc from "./questions/question_translations_misc.json";

    let { question_id, question_text, valence } = question;

    let value = "";

    $: if (!isNaN(parseInt(value))) {
        if (parseInt(value) == -1) {
            responses[questionset_id][question_id] = -1;
        } else {
            // translate user input (0-100) to a 0-10 with appropriate valence
            responses[questionset_id][question_id] =
                valence == "positive"
                    ? parseFloat(value) / 10
                    : 10 - parseFloat(value) / 10;
        }
    } else {
        responses[questionset_id][question_id] = "";
    }
</script>

<section>
    <div class="question">{@html question_text[user_language]}</div>
    <div class="slider">
        <!-- 
            Note: the `data-value` attribute on this slider is present 
            so that we can style this according to its value.
            See: https://stackoverflow.com/questions/70617584/apply-styles-based-on-the-html-range-input-values-css-only
        -->
        <div class="range-container">
            <input
                type="range"
                name={question_id}
                min="0"
                max="100"
                id="range_{question_id}"
                bind:value
                data-value={value}
                class:unselected={value === ""}
                class:NA={value === "-1"}
                list="steplist"
            />
            <datalist id="steplist">
                <option>0</option>
                <option>10</option>
                <option>20</option>
                <option>30</option>
                <option>40</option>
                <option>50</option>
                <option>60</option>
                <option>70</option>
                <option>80</option>
                <option>90</option>
                <option>100</option>
            </datalist>
        </div>
        <div
            class="echo"
            style:visibility={value === "" || parseInt(value) == -1
                ? "hidden"
                : ""}
        >
            {value}%
        </div>
        <div
            class="NA_option"
            on:click={() => {
                value = "-1";
            }}
            on:keyup={() => {value="-1"}}
            role="radio"
            aria-checked={value=="-1"}
            tabindex="-1"
        >
            <span class="na_bullet" class:checked={value == "-1"}></span>
            {question_translations_misc["NA"][user_language]}
        </div>
    </div>
</section>

<style lang="scss">
    section {
        margin: 2em auto;
    }

    .question {
        margin-bottom: 0.5em;
    }

    .NA_option {
        font-size: 0.75rem;
        font-style: italic;
        color: var(--color-grey-med);
        background-color: var(--color-background);
        font-weight: normal;
        cursor: default;
    }

    .slider {
        margin: 2em 4em;
        display: flex;
        justify-content: center;
        align-items: center;

        .range-container {
            flex-grow: 1;
            input[type="range"] {
                display: inline;
                width: 100%;

                &.unselected {
                    filter: saturate(0) opacity(0.5);
                }

                &.NA {
                    filter: saturate(0) opacity(0.5);

                    &::-webkit-slider-thumb {
                        visibility: hidden;
                    }
                }
            }
        }
        .echo {
            text-align: left;
            padding-left: 0.5rem;
            width: 3rem;
            font-weight: bold;
        }

        .na_bullet {
            outline: 1px dotted var(--color-grey-light);
            outline-offset: 2px;
            display: inline-block;
            width: 0.5rem;
            height: 0.5rem;
            margin-left: 0.25rem;
            margin-right: 0.25rem;
            border-radius: 50%;

            &.checked {
                outline: 1px solid var(--color-grey-med);
                background-color: var(--color-grey-med);
            }
        }
    }
</style>
